import { render, staticRenderFns } from "./CopySubdomain.vue?vue&type=template&id=16283c8a&"
import script from "./CopySubdomain.vue?vue&type=script&lang=js&"
export * from "./CopySubdomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports